import React from 'react'
import "./footer.css"
import Logo from "../../assets/images/mtg-logo-6.png"
import { BiPhone } from 'react-icons/bi'
import { MdOutlineEmail } from 'react-icons/md'
import { IoCallOutline, IoLocationOutline, IoMailOutline } from 'react-icons/io5'

const Footer = () => {
  return (
    <div className='footer-container relative overflow-hidden'>
      {/* <div class="absolute z-3 -left-40 top-4 h-[400px] w-[400px] rounded-full border-[60px] border-[#A6C1EE]"></div>
      <div class="absolute z-3 right-4 bottom-10 h-[400px] w-[400px] rounded-full border-[60px] border-[#A6C1EE]"></div> */}
      <div className='footer-top-container relative z-10'>

        <div className='w-[75%] mx-[auto]'>
          <img className='' src={Logo} alt="" />
          <p className='mt-4 text-[#0D0D0D] font-[300]'>Merge Turk Gold is a nature-friendly gold mining company in Ghana, specializing in alluvion and rock mining while preserving the environment.</p>
        </div>

        <div>
          <h3 className='footer-title'>Explore</h3>
          <div className='flex flex-column'>
            <a className='footer-link' href="/coming-soon">About Us</a>
            <a className='footer-link' href="/coming-soon">Our Services</a>       
            <a className='footer-link' href="/coming-soon">Our Technology</a>
            <a className='footer-link' href="/coming-soon">Environmental Commitment</a>
            <a className='footer-link' href="/coming-soon">News and Updates</a>
          </div>
        </div>

        <div>
          <h3 className='footer-title'>Careers & Investors</h3>
          <div className='flex flex-column'>
            <a className='footer-link' href="/coming-soon">Careers</a>
            <a className='footer-link' href="/coming-soon">Investors</a>
            <a className='footer-link' href="/coming-soon">Contact Us</a>
          </div>
        </div>

        <div>
          <h3 className='footer-title'>Reach Out</h3>
          <div className='flex flex-column'>
            <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoCallOutline /></div>
              <div className='col-span-7'>+90 555 555 55 55</div>
            </div>
            <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoMailOutline /></div>
              <div className='col-span-7'>info@mergeturkgold.com</div>
            </div>
            <div className='grid grid-cols-8 flex items-center footer-link'>
              <div className='col-span-1 text-2xl text-[#DAA521]'><IoLocationOutline /></div>
              <div className='col-span-7'>Accra</div>
            </div>
          </div>
        </div>

      </div>
      <div className='footer-bottom-container z-10 relative text-center py-[60px] text-[18px] text-[#6B7280] font-[300]'>
        <span>© Merge Turk Gold 2025</span>
      </div>
    </div>
  )
}

export default Footer